import { combineReducers } from 'redux'
import userDetails from './user.reducers'
import selectedCourse from './course.reducers'
import mySelectedCourses from './mycourses.reducers'
import getData from './data.reducers'
import tutorial from './tutorial.reducers'
import demo from './demo.reducers'
import popup1 from './popup.reducers'

export default combineReducers({
	userDetails,
	selectedCourse,
	mySelectedCourses,
	getData,
	tutorial,
	demo,
	popup1
	
})